import { z } from 'zod';

import { AvailabilityTypeZod } from 'types/zod/availability-type';
import { DocumentStatusTypeZod } from 'types/zod/document-status-type';
import { DocumentTypeCodeZod } from 'types/zod/document-type-code';

export const AssignedRoleZod = z.object({
    document_id: z.number(),
    document_name: z.string(),
    document_status_code: DocumentStatusTypeZod,
    document_type_code: DocumentTypeCodeZod,
    document_last_updated_timestamp: z.number(),
    group_mapping: z.string(),
    notify: z.boolean(),
    participant_role_id: z.number(),
    role_type_code: z.string(),
    visibility_code: AvailabilityTypeZod,
    scan_names: z.array(z.string()).optional(),
});
export type AssignedRole = z.infer<typeof AssignedRoleZod>;
